module.exports = __webpack_public_path__ + "img/101.08a18043.jpg";